import axios from "axios";
import mainApiClient from "../../helpers/services/main-api-client";
import {
  PostSessionRequest,
  PostSessionResponse,
} from "../interfaces/api/post-session";
import { PostSessionGoogleResponse } from "../interfaces/api/post-session-google";
import {
  PostSessionRefreshRequest,
  PostSessionRefreshResponse,
} from "../interfaces/api/post-sessionRefresh";
import { sessionMapper } from "./mapper";

const mainApiBaseUrl =
  process.env.REACT_APP_MAIN_URL || "http://localhost:4999/api";

export const sessionApiService = {
  postSession(email: string, password: string) {
    const body: PostSessionRequest = { email, password };
    return mainApiClient()
      .post<PostSessionResponse>(`session`, body)
      .then(({ data }) => sessionMapper.mapResponseToSession(data));
  },
  postSessionGoogle(idToken: string) {
    return axios
      .post<PostSessionGoogleResponse>(
        `${mainApiBaseUrl}/session/google`,
        { idToken },
        { headers: { "Content-Type": "application/json" } }
      )
      .then(({ data }) => sessionMapper.mapResponseToSession(data));
  },
  postSessionRefresh(email: string, refreshToken: string) {
    const body: PostSessionRefreshRequest = { email, refreshToken };
    return mainApiClient()
      .post<PostSessionRefreshResponse>(`session/refresh`, body)
      .then(({ data }) => sessionMapper.mapResponseToSession(data));
  },
};
